import { componentsStyles } from './components'
import { fontStyles } from './fonts'
import { globalStyles } from './global-styles'

const styles = {
  styles: {
    ...globalStyles,
  },
  ...componentsStyles,
  ...fontStyles,
}

export default styles
